var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 50,
    viewBox: "0 0 87 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    d: "M63.4844 49.9223C76.0769 49.9223 86.2852 39.4622 86.2852 26.559C86.2852 13.6559 76.0769 3.1958 63.4844 3.1958C50.8919 3.1958 40.6836 13.6559 40.6836 26.559C40.6836 39.4622 50.8919 49.9223 63.4844 49.9223Z",
    fill: "url(#paint0_radial_1_32434)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    d: "M23.3125 49.9223C35.905 49.9223 46.1133 39.4622 46.1133 26.559C46.1133 13.6559 35.905 3.1958 23.3125 3.1958C10.72 3.1958 0.511719 13.6559 0.511719 26.559C0.511719 39.4622 10.72 49.9223 23.3125 49.9223Z",
    fill: "url(#paint1_radial_1_32434)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.2266 24.8014V9.29263C73.2266 4.59219 69.5078 0.781738 64.9206 0.781738L49.7852 0.781738C45.1979 0.781738 41.4792 4.59219 41.4792 9.29263V24.8014C41.4792 29.5018 45.1979 33.3123 49.7852 33.3123H64.9206C69.5078 33.3123 73.2266 29.5018 73.2266 24.8014Z",
    fill: "url(#paint2_linear_1_32434)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2733 10.9165C62.0585 10.9165 61.8486 10.9818 61.67 11.104C61.4915 11.2263 61.3523 11.4 61.2701 11.6033C61.188 11.8066 61.1665 12.0303 61.2084 12.2461C61.2503 12.4619 61.3537 12.6601 61.5055 12.8157C61.6574 12.9713 61.8508 13.0773 62.0614 13.1202C62.272 13.1631 62.4904 13.1411 62.6887 13.0569C62.8871 12.9727 63.0567 12.8301 63.176 12.6471C63.2953 12.4642 63.359 12.2491 63.359 12.029C63.359 11.734 63.2446 11.451 63.041 11.2424C62.8374 11.0337 62.5612 10.9165 62.2733 10.9165Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4161 12.3506C56.5068 12.3484 55.6174 12.6228 54.8604 13.1391C54.1035 13.6553 53.5131 14.3902 53.1642 15.2506C52.8152 16.1109 52.7234 17.0581 52.9002 17.972C53.0771 18.8859 53.5147 19.7255 54.1577 20.3843C54.8006 21.0431 55.62 21.4915 56.5119 21.6728C57.4038 21.854 58.3282 21.7598 59.1678 21.4023C60.0075 21.0447 60.7246 20.4398 61.2285 19.6642C61.7323 18.8886 62.0001 17.9772 61.998 17.0455C61.9951 15.8012 61.5114 14.6088 60.6528 13.729C59.7941 12.8491 58.6304 12.3535 57.4161 12.3506ZM57.4161 20.0605C56.8337 20.0627 56.2637 19.8877 55.7784 19.5578C55.2931 19.2278 54.9143 18.7577 54.6899 18.207C54.4656 17.6563 54.4058 17.0497 54.5181 16.4642C54.6304 15.8786 54.9097 15.3403 55.3208 14.9176C55.7319 14.4948 56.2561 14.2065 56.8272 14.0893C57.3982 13.9721 57.9904 14.0311 58.5287 14.259C59.067 14.4868 59.5272 14.8733 59.851 15.3693C60.1748 15.8654 60.3476 16.4487 60.3476 17.0455C60.3476 17.8432 60.0391 18.6084 59.4896 19.1735C58.9402 19.7386 58.1946 20.0575 57.4161 20.0605Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0572 26.5912H53.6307C52.1486 26.5883 50.728 25.9837 49.68 24.9098C48.632 23.836 48.0419 22.3803 48.0391 20.8617V13.2408C48.0419 11.7221 48.632 10.2665 49.68 9.19262C50.728 8.11876 52.1486 7.51417 53.6307 7.51123H61.0572C62.5393 7.51417 63.9599 8.11876 65.0079 9.19262C66.056 10.2665 66.646 11.7221 66.6489 13.2408V20.8617C66.646 22.3803 66.056 23.836 65.0079 24.9098C63.9599 25.9837 62.5393 26.5883 61.0572 26.5912ZM53.6307 9.31353C52.6132 9.31353 51.6372 9.72694 50.9167 10.4631C50.1962 11.1993 49.79 12.1982 49.7871 13.2408V20.8617C49.79 21.9042 50.1962 22.9031 50.9167 23.6393C51.6372 24.3755 52.6132 24.7889 53.6307 24.7889H61.0572C62.0747 24.7889 63.0507 24.3755 63.7712 23.6393C64.4917 22.9031 64.8979 21.9042 64.9008 20.8617V13.2408C64.8979 12.1982 64.4917 11.1993 63.7712 10.4631C63.0507 9.72694 62.0747 9.31353 61.0572 9.31353H53.6307Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1_32434",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.4844 26.559) scale(22.8008 23.3632)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000056"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#7373A2",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#D9D9E6",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1_32434",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.3125 26.559) scale(22.8008 23.3632)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000056"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#7373A2",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#D9D9E6",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_32434",
    x1: 73.5523,
    y1: 0.436852,
    x2: 31.4887,
    y2: 41.4878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBE18A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FCBB45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#F75274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#D53692"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#8F39CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B4FE9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.a263bf804ee8833a896806d7e79286fb.svg";
export { ForwardRef as ReactComponent };